var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgStarDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.197 5.466-4.37-.629L8.854.857C8.523.17 7.506.14 7.147.858l-1.945 3.98-4.398.629c-.778.12-1.078 1.077-.51 1.645l3.143 3.083-.748 4.338c-.12.778.718 1.377 1.406 1.018l3.92-2.065 3.89 2.065c.688.359 1.526-.24 1.406-1.018l-.748-4.338 3.142-3.083c.569-.568.27-1.526-.508-1.645m-4.19 4.219.718 4.13-3.71-1.946-3.74 1.945.718-4.13L1.97 6.753l4.159-.598 1.885-3.77 1.855 3.77 4.16.598z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarDefault);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;